const faq = (selector) => {
    const faq = document.querySelectorAll(selector);
    
    if(faq) {
        faq.forEach(i => {
            i.addEventListener('click', () => {
                i.nextElementSibling.classList.toggle('active-text');
                i.classList.toggle('rotate');
                i.classList.toggle('active');
            })
        })
    }

}

export default faq;